// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__cedAT","dragIcon":"SortableItem_dragIcon__3dkJs","disabled":"SortableItem_disabled__EVx3_"};